module.exports = __webpack_public_path__ + "img/payment_methods.5b9749a.png";


//////////////////
// WEBPACK FOOTER
// ./assets/img/payment_methods.png
// module id = ./assets/img/payment_methods.png
// module chunks = 2 3 4 5 6